import { format as dateFnsFormat } from 'date-fns';

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
  }).format(price);
}

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return dateFnsFormat(d, 'EEEE, d MMMM yyyy');
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  }).format(amount);
}

export function formatTime(time: string): string {
  return dateFnsFormat(new Date(`2000-01-01T${time}`), 'h:mm a');
}

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  }
  return phone;
}

export function formatDistance(distance: number): string {
  if (distance < 1) {
    return `${Math.round(distance * 1000)}m`;
  }
  return `${Math.round(distance)}km`;
}

export function formatAddressLine(address: {
  street_number?: string;
  street_name?: string;
  suburb?: string;
  state?: string;
  postcode?: string;
}): string {
  const parts = [];
  if (address.street_number && address.street_name) {
    parts.push(`${address.street_number} ${address.street_name}`);
  }
  if (address.suburb) parts.push(address.suburb);
  if (address.state) parts.push(address.state);
  if (address.postcode) parts.push(address.postcode);
  return parts.join(', ');
}

export function formatAddress(address: {
  street_number?: string;
  street_name?: string;
  suburb?: string;
  state?: string;
  postcode?: string;
}): string[] {
  const lines = [];
  if (address.street_number && address.street_name) {
    lines.push(`${address.street_number} ${address.street_name}`);
  }
  const locality = [address.suburb, address.state, address.postcode]
    .filter(Boolean)
    .join(' ');
  if (locality) lines.push(locality);
  return lines;
} 